import { useQuery } from "@tanstack/react-query";

import { getInvitationLink } from "~/patients/api/invitationLinks";

export const useGetInvitationLink = (invitationCode?: string) => {
  return useQuery({
    queryFn: () => getInvitationLink(invitationCode!),
    queryKey: ["getInvitationLink", invitationCode],
    retry: 1,
    enabled: !!invitationCode,
  });
};
